import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_PRJ_URL_data,   

});

// Automatically attach token to all requests
// api.interceptors.request.use((config) => {
//   const token = localStorage.getItem("token");
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`; // ✅ add token
//   }
//   return config;
// });

export default api;